import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { LanguageSelector } from '../LanguageSelector';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function Header({ empty }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { data: brandingData } = useSelector((state) => state.branding);

  return (
    <header className={classes.header} data-testid="header">
      <div className={classes.helperDiv} />
      <div className={classes.logoWrapper}>
        <img className={classes.logo} src={brandingData.icon} alt="Logo Icon" />
        <Typography className={classes.orgName} variant="h1" component="h1">
          {brandingData.displayName}
        </Typography>
      </div>
      {empty ? (
        <div className={classes.helperDiv} data-testid="empty-div" />
      ) : (
        <>
          <span className={classes.appTitle}>{t('request_an_appointment')}</span>
          <div className={classes.langSelectorWrapper}>
            <LanguageSelector />
          </div>
        </>
      )}
    </header>
  );
}

Header.propTypes = {
  empty: PropTypes.bool,
};

Header.defaultProps = {
  empty: false,
};

export default Header;
